import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ZoomText from './icon-zoom-text.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ZoomText {...validProps} />;
}
SvgComponent.iconName = 'zoomText';

/**
 * @deprecated This is a legacy icon
 */
export const ZoomTextIcon = svgIconWrapper(SvgComponent);
